import { queryInstructors } from '@wix/ambassador-achievements-instructors-v2-instructor/http';
import { extractProfileImagesFromInstructors } from './utils';
const PAGE_LIMIT = 100;
export const fetchOnlineProgramsInstructors = async (httpClient, errorHandler, programIds) => {
  const allInstructors = [];
  const {
    withErrorHandler
  } = errorHandler;
  if (!programIds) {
    return {
      imagesInstructorsMap: {},
      instructors: []
    };
  }
  let cursor;
  let hasMore = false;
  await withErrorHandler(async () => {
    do {
      var _pagingMetadata$curso;
      const {
        data
      } = await httpClient.request(queryInstructors({
        query: {
          cursorPaging: {
            cursor,
            limit: PAGE_LIMIT
          }
        }
      }));
      const {
        instructors,
        pagingMetadata
      } = data;
      allInstructors.push(...(instructors ?? []));
      hasMore = (pagingMetadata == null ? void 0 : pagingMetadata.hasNext) ?? false;
      cursor = pagingMetadata == null || (_pagingMetadata$curso = pagingMetadata.cursors) == null ? void 0 : _pagingMetadata$curso.next;
    } while (hasMore);
    return allInstructors;
  }, {
    errorCodesMap: {}
  });
  return extractProfileImagesFromInstructors(allInstructors);
};
//# sourceMappingURL=fetch-online-programs-instructors.js.map